import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateUnassignedBooking } from 'repositories/BerthApi/updateUnassignedBooking'
import { berthKeys, bookingKeys } from 'repositories/queryKeys'

export function useUpdateUnassignedBooking() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateUnassignedBooking,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.unassigned() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.details() })
    },
  })
}
